*,
::after,
::before {
  box-sizing: border-box;
}

:host {
  display: grid;
  position: relative;
  inline-size: 100%;
  block-size: 100%;
  grid-template: "more-actions actions" 1fr/min-content 1fr;
  overflow: hidden;
}

.more-actions {
  grid-area: more-actions;
}
.more-actions::part(expandable-button) {
  width: 1.375em;
  height: 1.375em;
}
.more-actions::part(expandable-button)::before {
  content: "";
  width: 100%;
  height: 100%;
  background-color: currentColor;
  -webkit-mask: url('data:image/svg+xml,<svg viewBox="0 0 25 25" xmlns="http://www.w3.org/2000/svg"><path d="M5.26837 10.5625C4.16837 10.5625 3.26837 11.4625 3.26837 12.5625C3.26837 13.6625 4.16837 14.5625 5.26837 14.5625C6.36837 14.5625 7.26837 13.6625 7.26837 12.5625C7.26837 11.4625 6.36837 10.5625 5.26837 10.5625ZM19.2684 10.5625C18.1684 10.5625 17.2684 11.4625 17.2684 12.5625C17.2684 13.6625 18.1684 14.5625 19.2684 14.5625C20.3684 14.5625 21.2684 13.6625 21.2684 12.5625C21.2684 11.4625 20.3684 10.5625 19.2684 10.5625ZM12.2684 10.5625C11.1684 10.5625 10.2684 11.4625 10.2684 12.5625C10.2684 13.6625 11.1684 14.5625 12.2684 14.5625C13.3684 14.5625 14.2684 13.6625 14.2684 12.5625C14.2684 11.4625 13.3684 10.5625 12.2684 10.5625Z"/></svg>') 50% 50%/1.25em 1.25em no-repeat;
}

.actions {
  grid-area: actions;
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: max-content;
  width: 100%;
  max-width: 100%;
}
.actions--responsive {
  position: absolute;
  inset: 0;
}
.actions--scroll {
  overflow-x: auto;
}
.actions--multiline {
  display: flex;
  flex-wrap: wrap;
}